var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lifestyle2-template',{attrs:{"current-stress-level":_vm.currentStressLevel,"sleep-deprived":_vm.sleepDeprived,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }